/**
 * Order
 */
import moment from 'moment';

let initForm = {
    id: null,
    type: 1,
    name: '',
    reg_address: '',
    postal_address: '',
    address: '',
    inn: '',
    kpp: '',
    rs: '',
    bank: '',
    ks: '',
    bik: '',
    ogrnip: '',
    reg_cert: '',
    reg_date: '',
    gender: null,
    birth_date: '',
    doc_number: '',
    doc_date: '',
    doc_expired: '',
    email: '',
    phone: '',
    has_history: null,
    has_stamp: null,
}

export const payer = {
    namespaced: true,

    state: () => ({
        payers: [],
        payer: { ...initForm },
        editMode: false,
        oldName: '',
        saving: false,
        errors: {},
        ok: false,
        lastId: null
    }),

    mutations: {
        setPayers: (state, payload) => {
            state.payers = payload.items;
        },

        setPayer: (state, payload) => {
            state.payer = payload.data;
            state.oldName = payload.data.name;
            state.editMode = true;
        },

        setForm: (state, payload) => {
            state.payer = { ...state.payer, ...payload };
        },

        resetErrors: (state, payload) => {
            state.errors = {};
        },

        setErrors: (state, payload) => {
            state.errors = {
                ...state.errors,
                ...payload
            };
        },

        resetForm: (state, payload) => {
            state.errors = {};
            state.oldName = '';
            state.editMode = false;
            state.payer = { ...initForm };
        },

        setSaving: (state, payload) => {
            state.saving = payload;
        },

        setOk: (state, payload) => {
            state.ok = payload;
        },

        setLastId: (state, payload) => {
            state.lastId = payload;
        },
    },

    actions: {
        getPayers: async ({ commit }, payload) => {
            let { data } = await axios.get('/ajax/payers');

            commit('setPayers', data);
        },

        addPayer: ({ commit, dispatch, state }, payload) => {
            let params = {
                ...state.payer,

                // Приводим дату из datepicker в нужный формат
                birth_date: state.payer.birth_date ? moment(state.payer.birth_date).format('yyyy-MM-DD') : null,
                doc_date: state.payer.doc_date ? moment(state.payer.doc_date).format('yyyy-MM-DD') : null,
                doc_expired: state.payer.doc_expired ? moment(state.payer.doc_expired).format('yyyy-MM-DD') : null,
                reg_date: state.payer.reg_date ? moment(state.payer.reg_date).format('yyyy-MM-DD') : null,
            };

            commit('setSaving', true);
            commit('resetErrors');

            axios.post('/ajax/payers/store', params)
                .then(response => {
                    if (response.data.success === true) {

                        // Metrika
                        let target = '';

                        switch (parseInt(state.payer.type)) {
                            case 1: target = 'creation_company'; break;
                            case 2: target = 'creation_entrepreneur'; break;
                            case 3: target = 'creation_individual'; break;
                        }

                        ym(191405, 'reachGoal', target);


                        commit('setSaving', false);
                        commit('setOk', true);
                        commit('setLastId', response.data.id);
                        commit('resetForm');

                        dispatch('getPayers');

                        setTimeout(() => {
                            commit('setOk', false);
                        }, 5000);
                    } else {
                        if (response.data.success === false && typeof response.data.errors !== 'undefined') {
                            commit('setSaving', false);
                            commit("setErrors", response.data.errors);
                        }
                    }
                });
        },

        updatePayer: ({ commit, dispatch, state }, payload) => {
            let params = {
                ...state.payer,

                // Приводим дату из datepicker в нужный формат
                birth_date: state.payer.birth_date ? moment(state.payer.birth_date).format('yyyy-MM-DD') : null,
                doc_date: state.payer.doc_date ? moment(state.payer.doc_date).format('yyyy-MM-DD') : null,
                doc_expired: state.payer.doc_expired ? moment(state.payer.doc_expired).format('yyyy-MM-DD') : null,
                reg_date: state.payer.reg_date ? moment(state.payer.reg_date).format('yyyy-MM-DD') : null,
            };

            commit('setSaving', true);
            commit('resetErrors');

            axios.put('/ajax/payers/update', params)
                .then(response => {
                    commit('setSaving', false);
                    commit('setOk', true);
                    commit('setLastId', response.data.id);
                    commit('resetForm');

                    dispatch('getPayers', payload);

                    setTimeout(() => {
                        commit('setOk', false);
                    }, 5000);
                });
        },

        deletePayer: ({ commit, dispatch }, payload) => {
            axios.delete('/ajax/payers/destroy/' + payload)
                .then(request => dispatch('getPayers'));
        },

        getPayer: ({ commit, dispatch }, payload) => {
            return axios.get('/ajax/payers/' + payload)
                .then(request => commit('setPayer', request.data));
        },

        getPayerByINN: ({ commit, dispatch }, payload) => {
            commit('resetErrors');

            return axios.get('/ajax/payers/inn/' + payload)
                .then(request => {
                    if (true === request.data.success) {
                        commit('setForm', request.data.data);
                    } else {
                        commit('setErrors', request.data.errors);
                    }
                });
        },

        uploadFiles: ({ commit, dispatch }, payload) => {
            axios.post( '/ajax/payers/upload',
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(request => commit('setPayer', request.data));
        },
    },

    getters: {
        // items: state => {
        //     return state.items;
        // },
        // amount: state => {
        //     return state.amount;
        // },
    }
}
